import React from 'react';
import { Button } from '@paypalcorp/pp-react';
import getContent from '../lib/dictionaryFetcher';
import PropTypes from 'prop-types';

const ResultsHeaderView = props => {
  const { shouldShowZeroState, maxLength, submitResults } = props;
  return (
    <React.Fragment>
      <h1 className="results-title">
        {getContent('quiz', 'results.header', '')}
      </h1>
      <div
        className="results-subcontent"
        style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}
      >
        <p className="results-subcontent-title">
          {getContent('quiz', 'results.subtitle', '')}
        </p>
        {shouldShowZeroState !== maxLength && (
          <Button
            onClick={() => {
              submitResults(['userProducts', 'developerProducts']);
            }}
            className="results-subcontent-button"
            style={{ marginLeft: 'auto' }}
          >
            {getContent('quiz', 'results.start')}
          </Button>
        )}
      </div>
    </React.Fragment>
  );
};

ResultsHeaderView.propTypes = {
  shouldShowZeroState: PropTypes.number,
  maxLength: PropTypes.number,
  submitResults: PropTypes.func
};

export default ResultsHeaderView;
